<div class="admin-shared-files-container container">
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">فایل‌های به اشتراک گذاری شده</h2>
    <div class="actions">
      <mat-form-field appearance="fill" style="display: none">
        <mat-select #type placeholder="وضعیت">
          <mat-option value="">بدون فیلتر</mat-option>
          <mat-option value="payment">در انتظار پرداخت</mat-option>
          <mat-option value="calculation">تخمین قیمت</mat-option>
          <mat-option value="progress">در حال انجام</mat-option>
          <mat-option value="done">انجام شده</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-flat-button id="exportToExcelButton">
        <span>خروجی اکسل</span>
        <jam-icon
          name="database"
          vertical-align="middle"
          color="primary"
        />
      </button>
      <button
        mat-icon-button
        (click)="refreshController$.next('')"
        color="primary"
      >
        <jam-icon name="refresh" />
      </button>
      <button mat-icon-button>
        <jam-icon name="more-vertical-f" />
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <br />

  <h1
    *ngIf="this.dataSource.data && this.dataSource.data.length <= 0"
    style="text-align: center"
  >
    موردی پیدا نشد
  </h1>

  <div class="table-actions" fxLayout="row" fxLayoutAlign="space-between">
    <mat-form-field appearance="outline">
      <input
        #idSearch
        (keyup)="searchController$.next({ searchString: idSearch.value! })"
        matInput
        placeholder="شماره سبد، شماره کاربر"
      />
      <jam-icon name="search" matSuffix />
    </mat-form-field>

    <div class="date-range" fxLayout="row" fxLayoutAlign="center center">
      <mat-form-field appearance="outline">
        <mat-label>بازه زمانی</mat-label>

        <button
          mat-icon-button
          color="warn"
          *ngIf="startDate.value && endDate.value"
          (click)="range.reset(); refreshController$.next('')"
          matSuffix
        >
          <jam-icon name="close" />
        </button>

        <mat-date-range-input
          [formGroup]="range"
          [rangePicker]="dateRangePicker"
        >
          <input
            #startDate
            matStartDate
            formControlName="start"
            placeholder="شروع"
          />
          <input
            #endDate
            matEndDate
            formControlName="end"
            placeholder="پایان"
          />
        </mat-date-range-input>

        <mat-datepicker-toggle matSuffix [for]="dateRangePicker">
        </mat-datepicker-toggle>
        <mat-date-range-picker #dateRangePicker />
      </mat-form-field>

      <button
        id="searchButton"
        mat-button
        [disabled]="range.invalid"
        color="primary"
        (click)="searchController$.next(undefined)"
      >
        <jam-icon name="search" />
      </button>
    </div>
  </div>

  <div class="admin-user-list-table-container mat-elevation-z2">
    <div class="example-container mat-elevation-z8">
      <div
        class="example-loading-shade"
        *ngIf="isLoadingResult || isRateLimitReached"
      >
        <mat-spinner *ngIf="isLoadingResult" />
      </div>

      <table mat-table [dataSource]="dataSource" matSort>
        <!-- Position Column -->
        <ng-container matColumnDef="user_id">
          <th mat-header-cell *matHeaderCellDef>شماره مشتری</th>
          <td mat-cell *matCellDef="let element">
            {{ element.user_id | digitsEnToFa }}
          </td>
        </ng-container>

        <ng-container matColumnDef="user_avatar">
          <th mat-header-cell *matHeaderCellDef>آواتار کاربر</th>
          <td mat-cell *matCellDef="let element">
            <img
              style="width: 30px; border-radius: 100%"
              referrerpolicy="no-referrer"
              [src]="
                element.avatar_url || 'assets/image/user-avatar-placeholder.jpg'
              "
            />
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="user_fullName">
          <th mat-header-cell *matHeaderCellDef>نام و نام خانوادگی</th>
          <td mat-cell *matCellDef="let element">
            {{ element.user_fullName | summary : 20 }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="totalvalue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ارزش مشتری</th>
          <td mat-cell *matCellDef="let element">
            {{ element.totalvalue | irc : "T" }}
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="totalsharedfiles">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            فایل‌های اشتراکی
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-flat-button>
              {{ element.totalsharedfiles || 0 }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="totalScore">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>مجموع امتیاز</th>
          <td mat-cell *matCellDef="let element">
            {{ element.user_score | number: '1.' }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="totalScore">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ارزش مشتری</th>
          <td mat-cell *matCellDef="let element">
            {{ element.user_score | number: '1.' }}
          </td>
        </ng-container> -->

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>عملیات</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              color="primary"
              [routerLink]="[element.user_id.toString()]"
            >
              <jam-icon name="search-folder" />
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[5, 10, resultsLength]"
        [length]="resultsLength"
        class="paginator"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      />
    </div>
  </div>
</div>
